import React, { useState, useEffect } from 'react';
import CanvasJSReact from '@canvasjs/react-charts'; // Import CanvasJSReact from the installed package
import { Alert, Badge } from 'react-bootstrap';
import { Activity, HeartPulse } from 'lucide-react';
var CanvasJSChart = CanvasJSReact.CanvasJSChart;





var numbersArray = [
  -33, -31, -39, -41, -37, -31, -27, -19, -15, -13, -13, -25, -25, -25, -23, -25, -33, -23, -29, -23,
  -27, -27, -25, -35, -29, -25, -29, -29, -27, -33, -31, -19, -21, -15, -17, 5, 5, -5, -17, -23, -29,
  -25, -31, -41, -43, -43, -33, -33, -31, -123, -171, -37, 259, 515, 535, 489, 147, -83, -59, -57, -69,
  -73, -69, -61, -63, -61, -53, -47, -53, -49, -43, -39, -35, -37, -31, -25, -29, -25, -29, -31, -37,
  -35, -35, -33, -33, -23, -13, -19, -23, -15, -23, -31, -21, -25, -27, -25, -23, -21, -27, -27, -27,
  -29, -25, -23, -27, -27, -33, -31, -23, -17, -11, -11, -9, 13, 1, -3, -11, -23, -27, -27, -35, -41,
  -45, -35, -35, -31, -51, -175, -129, 129, 463, 585, 545, 245, -37, -55, -55, -57, -57, -67, -61, -57,
  -55, -55, -49, -49, -45, -39, -41, -33, -25, -27, -21, -23, -23, -19, -31, -33, -37, -37, -35, -39,
  -27, -21, -21, -19, -19, -23, -21, -23, -23, -25, -23, -23, -23, -23, -21, -21, -19, -25, -23, -21,
  -19, -21, -21, -21, -15, -9, -7, -5, 13, 3, -11, -19, -9, -19, -29, -31, -31, -37, -37, -33, -31,
  -31, -137, -169, 11, 329, 545, 571, 451, 99, -51, -43, -51, -59, -61, -67, -61, -69, -61, -53, -53,
  -53, -41, -43, -37, -33, -27, -31, -21, -25, -29, -27, -23, -35, -39, -43, -37, -37, -31, -25, -25,
  -27, -21, -25, -27, -33, -35, -35, -19, -25, -27, -29, -25, -23, -19, -25, -31, -25, -25, -33, -27,
  -23, -11, -7, -17, -9, 9, -1, -9, -25, -29, -23, -27, -35, -45, -41, -41, -49, -37, -39, -167, -155,
  59, 417, 577, 529, 315, 1, -61, -53, -63, -71, -71, -73, -75, -67, -59, -57, -57, -53, -51, -49, -41,
  -35, -37, -29, -31, -35, -29, -43, -43, -43, -53, -49, -45, -35, -37, -35, -35, -35, -33, -35, -37,
  -41, -37, -37, -37, -33, -35, -39, -33, -37, -39, -33, -35, -35, -35, -37, -37, -39, -41, -25, -25,
  -29, -19, -5, -7, -15, -23, -29, -35, -43, -45, -47, -49, -51, -49, -47, -37, -145, -181, -21, 329,
  523, 507, 365, 55, -69, -65, -67, -73, -75, -79, -75, -79, -71, -65, -69, -65, -57, -57, -51, -55,
  -59, -27, -37, -37, -37, -43, -43, -57, -59, -61, -45, -39, -31, -29, -35, -33, -41, -29, -37, -43,
  -43, -37, -39, -51, -37, -41, -45, -33, -31, -37, -41, -41, -43, -35, -37, -43, -37, -25, -25, -31,
  -19, 1, -13, -27, -29, -21, -33, -43, -45, -53, -47, -53, -55, -41, -65, -183, -139, 109, 431, 531,
  475, 211, -43, -67, -69, -75, -73, -77, -79, -73, -75, -71, -65, -63, -55, -49, -47, -43, -45, -41,
  -39, -41, -37, -37, -41, -45, -43, -43, -51, -47, -37, -33, -29, -27, -31, -31, -29, -27, -31, -33,
  -33, -29, -33, -37, -29, -35, -27, -33, -27, -25, -27, -29, -29, -25, -27, -23, -15, -15, -19, 1,
  15, -1, -11, -19, -15, -23, -29, -45, -35, -33, -39, -31, -27, -37, -149, -139, 95, 441, 559, 517,
  283, -11, -59, -53, -59, -57, -57, -61, -59, -51, -55, -55, -45, -39, -37, -35, -31, -29, -29, -23,
  -27, -23, -21, -33, -29, -39, -33, -25, -29, -21, -11, -15, -15, -19, -13, -15, -21, -19, -17, -27,
  -25, -19, -23, -19, -23, -21, -21, -21, -33, -29, -13, -19, -19, -13, -3, -7, -5, 17, 3, -9, -17,
  -17, -21, -31, -31, -31, -37, -35, -35, -27, -61, -171, -91, 179, 491, 563, 509, 245, -25, -65, -51,
  -57, -61, -67, -61, -55, -55, -61, -47, -47, -43, -41, -35, -31, -27, -31, -19, -21, -31, -27, -21,
  -29, -27, -39, -33, -23, -21, -25, -17, -15, -15, -15, -21, -27, -25, -23, -19, -23, -27, -15, -19,
  -21, -23, -21, -21, -19, -17, -15, -19, -19, -7, -1, -11, -3, 17, 9, -1, -13, -11, -11, -17, -25,
  -37, -25, -29, -31, -25, -31, -147, -143, 77, 401, 561, 547, 327, 15, -41, -43, -45, -55, -61, -57,
  -55, -53, -51, -55, -45, -35, -39, -35, -25, -15, -21, -15, -25, -19, -9, -17, -29, -37, -51, -41,
  -35, -29, -33, -23, -17, -17, -21, -23, -21, -27, -29, -21, -25, -27, -23, -21, -25, -25, -33, -19,
  -15, -21, -25, -27, -23, -23, -23, -7, -9, -13, 5, 9, -5, -15, -21, -23, -23, -29, -35, -39, -51,
  -37, -31, -27, -81, -161, -89, 205, 493, 571, 493, 199, -21, -45, -53, -59, -67, -65, -65, -67, -63,
  -57, -51, -53, -53, -43, -41, -39, -33, -25, -29, -31, -29, -25, -43, -33, -35, -39, -33, -31, -25,
  -19, -21, -19, -27, -27, -27, -33,
];

var datapoint = [];

for (let i = 1; i <= 795; i++) {
  datapoint.push({ x: i * 0.0078125, y: numbersArray[i - 1] / 200 });
}



const ChartComponent = ({ datapoints, patient }) => {

  const options = {
    animationEnabled: true,
    exportEnabled: true,
    theme: "light2", // "light1", "dark1", "dark2"
    title: {
      text: `ECG of ${patient && patient.name}  time:${patient && new Date(patient.createdAt).toLocaleString()}`
    },
    axisY: {
      title: "Magnitude",
      suffix: ""
    },
    axisX: {
      title: "time",
      prefix: "",

    },
    data: [{
      type: "line",
      toolTipContent: "ecg  {x}: {y}",
      dataPoints:
        datapoints

    }]
  }

  return (
    <div>

      <Alert>
        <h2 className='text-center'>Reports</h2>

        <p style={{ fontSize: "20px" }}><HeartPulse size={20} /> Heart rate: <Badge bg='success'>{patient.heartbeat} bpm</Badge></p>
        <p style={{ fontSize: "20px" }}> <Activity size={20} /> Spo2: <Badge bg='info'>{patient.spo2} </Badge></p></Alert>
      <CanvasJSChart options={options} />
    </div>
  );
};

export default ChartComponent;
